/*
* Copyright (C) Regione Lombardia
*/
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@shared/shared.module';
import { ToolkitGestioneUtenteFormComponent } from './form-utente/form-utente.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgbModule,
        SharedModule,
    ],
    declarations: [
        ToolkitGestioneUtenteFormComponent,
    ],
    exports: [
        ToolkitGestioneUtenteFormComponent,
    ],
    entryComponents: [
    ],
})
export class PagesGestioneUtenteToolkitModule { }
